import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { IoMdArrowBack } from "react-icons/io";

import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";

// services

// syncfusion
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  ExcelExport,
  Filter,
  GridComponent,
  Inject,
  Page,
  PdfExport,
  Resize,
  Sort,
  Toolbar,
} from "@syncfusion/ej2-react-grids";
import "@syncfusion/ej2-react-calendars/styles/tailwind.css";
import Spinner from "../Spinner";
import { vehicleService } from "../../../Services/vehicle.service";
import { toDateTime } from "../../../Services/string.service";
import SyncFusionDateTimePicker from "../SyncFusionDateTimePicker/SyncFusionDateTimePicker";
import { IoSearchOutline } from "react-icons/io5";
import EmptyData from "../../../components/EmptyData";

const PaginatedTableFleetCommands = (props) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { vehicleSelected: vehicleSelectedRedux } = useSelector(
    (rootReducer) => rootReducer.vehicleSelectedReducer,
  );

  // Usa o veículo selecionado da prop ou do Redux como fallback
  const vehicleSelected = props.selectedVehicle || vehicleSelectedRedux;

  const activeTab = useSelector((state) => state.activeTabReducer.activeTab);

  const [registers, setRegisters] = useState([]);

  const [dataLoading, setDataLoading] = useState(false);
  const [paginationState, setPaginationState] = useState({
    pageSize: 15,
    currentPage: 1,
    totalRecordsCount: 0,
  });

  const [startCommandsDate, setStartCommandsDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 365)),
  );
  const [endCommandsDate, setEndCommandsDate] = useState(new Date());

  const gridRef = useRef();

  const fetchVehicleCommands = async (vehicleId) => {
    setDataLoading(true);

    try {
      const payload = {
        vehicleId,
        startDate: props.startCommandsDate,
        EndDate: props.endCommandsDate,
      };

      const commands =
        await vehicleService.fetchVehicleCommandsHistory(payload);

      setRegisters(commands || []);
    } catch (error) {
      console.error(error);
    } finally {
      setDataLoading(false);
    }
  };

  const search = async () => {
    await fetchVehicleCommands(vehicleSelected.vehicleId);
  };

  const editing = {
    allowEditing: true,
    allowDeleting: true,
    allowAdding: false,
    mode: "Dialog",
  };

  const renderField = (field) => (props) => {
    const value = props[field];

    if (field === "generatedAt" || field === "finalizedAt") {
      return <span style={{ fontSize: "13px" }}>{toDateTime(value)}</span>;
    }

    return <span style={{ fontSize: "13px" }}>{value}</span>;
  };

  const renderFilter = (props) => {
    if (!props?.field || props.field === "generatedAt") return null;
    return null; // Ou seu filtro customizado
  };

  const getColumnProps = (field, index, props, renderField, renderFilter) => {
    const fieldExists = field == props.fields[index];
    let baseProps = {};

    if (field !== "location") {
      baseProps = {
        locale: "pt-BR",
        key: field,
        field,
        headerText: props.columns[index],
        width:
          field === "generatedAt"
            ? "30"
            : field === "command"
              ? "50"
              : field === "finalizedAt"
                ? "50"
                : field === "statusMessage"
                  ? "90"
                  : null,
        textAlign: "Left",
        editType: "dropdownedit",
        filterTemplate: field !== "generationDate" ? renderFilter : undefined,
      };
    } else {
      baseProps = {
        locale: "pt-BR",
        key: field,
        field,
        headerText: props.columns[index],
        textAlign: "Left",
        editType: "dropdownedit",
        filterTemplate: field !== "generatedAt" ? renderFilter : null,
        width: undefined,
      };
    }

    if (field === "generatedAt") {
      baseProps.textAlign = "Left";
      baseProps.type = "dateTime"; // informa o tipo
      baseProps.format = { type: "dateTime", format: "dd/MM/yyyy HH:mm:ss" }; // formata como desejado
      baseProps.allowFiltering = false;
      baseProps.allowSorting = false;
      baseProps.valueAccessor = (field, data) => {
        if (!data[field] || data[field] === "0001-01-01T00:00:00") return null;
        return new Date(data[field]); // converte string para objeto Date real
      };
    }

    if (field === "vehicleId") {
      baseProps.textAlign = "Center";
      baseProps.allowFiltering = false;
      baseProps.allowSorting = false;
    }

    if (fieldExists) {
      baseProps.template = renderField(field);
    }

    return baseProps;
  };

  const handleActiveTabPositions = async () => {
    const activeTab = "positions";
    dispatch({ type: "activeTab", value: activeTab });
    props.chooseDisplay(activeTab, vehicleSelected.vehicleId);
  };

  // Ao entrar na tela atualiza o tamanho de itens do grid de acordo com altura da tela
  const calculatePageSize = () => {
    const rowHeight = 25;
    const headerHeight = 200;
    const toolbarHeight = 60;
    const extraMargin = 40;
    const availableHeight =
      window.innerHeight - headerHeight - toolbarHeight - extraMargin;

    return Math.floor(availableHeight / rowHeight);
  };
  // useEffect(() => {

  //     if (activeTab === "commands") {

  //         calculatePageSize();
  //         window.addEventListener("resize", calculatePageSize);

  //         return () => window.removeEventListener("resize", calculatePageSize);
  //     }
  // }, [activeTab]);

  // Seta quantidade de itens da paginação do grid.
  useEffect(() => {
    const handleResize = () => {
      if (activeTab === "commands") {
        const pageSize = calculatePageSize();

        setPaginationState((prev) => ({
          ...prev,
          pageSize,
          currentPage: 1,
        }));
      }
    };

    // Chama logo de cara quando ativa o tab
    if (activeTab === "commands") {
      handleResize();
    }

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [activeTab]);

  useEffect(() => {
    (async () => {
      if (activeTab === "commands") {
        await fetchVehicleCommands(vehicleSelected.vehicleId);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab]);

  return (
    <>
      {dataLoading ? (
        <Spinner />
      ) : (
        <>
          <div className="back-to-fleet" style={{ marginBottom: 8 }}>
            <button
              style={{ display: "flex", alignItems: "center" }}
              onClick={() => handleActiveTabPositions()}
            >
              <div className="icon-back-fleet">
                <IoMdArrowBack />
              </div>
              <span>{t("FLEET.BACK")}</span>
            </button>
          </div>
          <div className="card">
            <div style={{ display: "flex", alignItems: "center" }}>
              <h4 style={{ padding: 16, margin: 0 }}>
                {t("COMMANDS.COMMAND_HISTORY")}
              </h4>
              <span style={{ marginTop: 7, marginRight: 10 }}>
                {t("FILTERS_COMPONENT.VEHICLE")}:{" "}
                <strong>{vehicleSelected.plate}</strong>
              </span>
              <span style={{ marginTop: 7 }}>
                {t("FLEET.THIS_VEHICLE_HAS_BLOCK")}
              </span>
            </div>
            <div className="table-responsive" style={{ margin: 4 }}>
              {props.dataLoading ? (
                <Spinner />
              ) : (
                <div className="control-pane">
                  <div className="control-section">
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginLeft: 4,
                        position: "relative",
                      }}
                    >
                      {/* <div
                        style={{ display: "flex", justifyContent: "flex-end" }}
                        >
                        <ReportDropDown
                          vehicleId={vehicleSelected}
                          selectedVehicle={props.vehicleFilter}
                          loading={dataLoading}
                          />
                          </div> */}
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        margin: 8,
                      }}
                    >
                      <div style={{ marginRight: 8 }}>
                        <SyncFusionDateTimePicker
                          id="datetimepickerStart"
                          value={startCommandsDate}
                          onChange={setStartCommandsDate}
                          placeholder={t("SEARCH.INITIAL_TIME")}
                        />
                      </div>

                      <div style={{ marginRight: 8 }}>
                        <SyncFusionDateTimePicker
                          id="datetimepickerStart"
                          value={endCommandsDate}
                          onChange={setEndCommandsDate}
                          placeholder={t("SEARCH.FINAL_TIME")}
                        />
                      </div>
                      <div style={{ marginRight: 8 }}>
                        <OverlayTrigger
                          placement="top"
                          overlay={
                            <Tooltip id="tooltip-mapa">
                              {t("COMMON.SEARCH")}
                            </Tooltip>
                          }
                        >
                          <button
                            type="button"
                            className={`btn btn-outline-secondary`}
                            onClick={async () => search()}
                          >
                            <IoSearchOutline
                              className="icon-in-button-frotas"
                              size={18}
                            />
                          </button>
                        </OverlayTrigger>
                      </div>
                    </div>
                    {registers.length === 0 ? (
                      <EmptyData />
                    ) : (
                      <GridComponent
                        ref={gridRef}
                        locale="pt-BR"
                        id="gridcomp"
                        dataSource={registers}
                        allowPaging={true}
                        allowSorting={true}
                        allowFiltering={true}
                        filterSettings={{ type: "CheckBox" }}
                        allowExcelExport={true}
                        allowPdfExport={true}
                        editSettings={editing}
                        width="100%"
                        allowResizing={true}
                        pageSettings={paginationState}
                      >
                        <ColumnsDirective>
                          {props.fields.map((field, index) => (
                            <ColumnDirective
                              {...getColumnProps(
                                field,
                                index,
                                props,
                                renderField,
                                renderFilter,
                              )}
                            />
                          ))}
                        </ColumnsDirective>

                        <Inject
                          services={[
                            Resize,
                            Sort,
                            Page,
                            ExcelExport,
                            Edit,
                            PdfExport,
                            Filter,
                            Toolbar,
                          ]}
                        />
                      </GridComponent>
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default PaginatedTableFleetCommands;
